import GradientButton from '../../../components/Buttons/GradientButton'
import HeroHeading from '../../../components/Headings/HeroHeading'
import HeroDescription from '../../../components/Headings/HeroDescription'
import Image from 'next/image'

const Hero = ({ onApplyClick }) => {
    return (
        <div className="bg-light-yellow-gradient-transparent flex py-16 px-4 sm:px-6 lg:pt-24 pb-0 lg:px-8">
            <div className="flex relative flex-col lg:flex-row max-w-7xl m-auto">
                <div className="w-28 h-full align-start hidden md:block z-1 lg:block">
                    <img src="assets/landing/join-affiliate/hero-left.png" />
                </div>

                <div className="md:hidden absolute overflow-hidden ">
                    <img src="assets/landing/join-affiliate/hero-left-mobile.png" />
                </div>

                <div className="max-w-4xl mx-auto text-center md:space-y-4 space-y-10 flex-1">
                    <div className="">
                        <Image
                            height="150"
                            width="270"
                            src="/assets/OLM_Logo-1.svg"
                        />
                    </div>

                    <HeroHeading>
                        <div className="space-y-2 space-x-1 hidden md:block">
                            <p>Join Our Affiliate Program</p>
                            <span>and</span>
                            <span className="olm-gradient-text">
                                Start Earning Today!
                            </span>
                        </div>
                        <div className="space-y-2 space-x-2 md:hidden">
                            <span> Join Our Affiliate Program and</span>
                            <span className="olm-gradient-text">
                                Start Earning Today!
                            </span>
                        </div>
                    </HeroHeading>
                    <HeroDescription>
                        Welcome to the Open Letter Marketing Affiliate Program!
                        Join our community and help real estate professionals
                        maximize their marketing efforts while earning
                        commissions and accessing exclusive resources.
                    </HeroDescription>
                    <div className="w-72 max-w-full m-auto">
                        <GradientButton onClick={onApplyClick}>
                            Apply Now
                        </GradientButton>
                    </div>
                </div>

                <div className="w-28 h-full align-end hidden lg:block">
                    <img src="/assets/landing/join-affiliate/hero-right.png" />
                </div>

                <div className="md:hidden relative my-10 text-center">
                    <div className="w-full m-auto -right-2 overflow-hidden absolute">
                        <img src="assets/landing/join-affiliate/hero-right-mobile.png" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero
